import { render, staticRenderFns } from "./Connexin.vue?vue&type=template&id=c3f14206"
import script from "./Connexin.vue?vue&type=script&lang=js"
export * from "./Connexin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports